// @flow

import * as React from 'react';
import './T4BIcon.less';

/** Component props for an T4BIcon */
export type Props = {|
  /** The icon name */
  name: string,

  /** The css class name */
  className: string,
|};

/**
 * Render an icon from the T4B_TripAdvisor icon font
 */
const T4BIcon = ({ name, className }: Props) => (
  <span className={`t4b_ui_icon ${name} ${className}`} />
);

T4BIcon.defaultProps = {
  className: '',
};

export default T4BIcon;
